import React, { useRef, useState, useEffect } from "react";
import $ from "jquery";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";

let interactionFlag = false;
const BombaCauldronAboboraBonus = ({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, walletBalance, denomination, gameResult }) => {
    const boxesArr = [0, 1, 2, 3, 4];
    const [boxValues, setBoxValues] = useState(Array(boxesArr.length).fill(0));
    const [selectedBoxArray, setSelectedBoxArray] = useState([]);
    const [isAnimatingPremioValue, setISAnimatingPremioValue] = useState(false);
    const [isAnimatingBonusValue, setIsAnimatingBonusValue] = useState(false);
    const [bonusValue, setBonusValue] = useState(0);
    const [premioValue, setPremioValue] = useState(0);
    const [selectedBoxIndex, setSelectedBoxIndex] = useState(null);
    const jumpingPumpKin04_BgRef = useRef(null);
    const jumpingPumpKin04_SelectRef = useRef(null);
    // Holds the Web Audio context/source used for the seamless (gapless) bg loop
    const bgAudioRef = useRef({ audioCtx: null, source: null });
    const keys = {
        "y": 0,
        "j": 1,
        "h": 2,
        "m": 3,
        "n": 4
    }

    const playSoundInLoop = () => {
        let sound = jumpingPumpKin04_BgRef.current;
        if (sound) {
            sound.currentTime = 0;
            sound.loop = true;
            sound.play().catch((err) => {
                console.error("Audio play failed:", err);
            });
        }
    };

    useEffect(() => {
        jumpingPumpKin04_BgRef.current = $("#jumpingPumpKin04-Bg")[0];

        const AudioCtx = window.AudioContext || window.webkitAudioContext;

        // Fallback: native HTML5 audio loop (may have a small gap at the loop point)
        const playWithElement = () => {
            const el = jumpingPumpKin04_BgRef.current;
            if (el) {
                el.loop = true;
                if (el.paused) {
                    el.play().catch((err) => {
                        console.error("Audio play failed:", err);
                    });
                }
            }
        };

        if (!AudioCtx) {
            playWithElement();
            return;
        }

        // Web Audio API gives a truly seamless (gapless) loop for the short bg clip
        let cancelled = false;
        const audioCtx = new AudioCtx();
        bgAudioRef.current.audioCtx = audioCtx;

        fetch("assets/pumpkin-bg.ogg")
            .then((res) => res.arrayBuffer())
            .then((data) => audioCtx.decodeAudioData(data))
            .then((audioBuffer) => {
                if (cancelled) return;
                const source = audioCtx.createBufferSource();
                source.buffer = audioBuffer;
                source.loop = true;
                source.connect(audioCtx.destination);
                source.start(0);
                bgAudioRef.current.source = source;
                if (audioCtx.state === "suspended") {
                    audioCtx.resume().catch(() => { });
                }
            })
            .catch((err) => {
                console.error("Background loop (Web Audio) failed, falling back:", err);
                playWithElement();
            });

        return () => {
            cancelled = true;
            const { source, audioCtx: ctx } = bgAudioRef.current;
            if (source) {
                try { source.stop(); } catch (e) { /* already stopped */ }
            }
            if (ctx) {
                ctx.close().catch(() => { });
            }
            bgAudioRef.current = { audioCtx: null, source: null };
        };
    }, [])

    const stopBackgroundLoop = () => {
        const { source } = bgAudioRef.current;
        if (source) {
            try { source.stop(); } catch (e) { /* already stopped */ }
            bgAudioRef.current.source = null;
        }
        if (jumpingPumpKin04_BgRef.current) {
            jumpingPumpKin04_BgRef.current.pause();
        }
    };




    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();

            if (Object.keys(keys).includes(key)) {
                handleCauldronClick(keys[key], boxesArr[keys[key]])
            }
        };

        if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId]);

    // playback handled during initialization; avoid duplicate play calls
    const animatePremioValue = (totalGameWinning) => {
        if (isAnimatingPremioValue) return;
        setISAnimatingPremioValue(true);

        let currentValue = totalGameWinning;
        const steps = 50;
        const stepSize = totalGameWinning / steps;
        const animationSpeed = 10;

        const intervalId = setInterval(() => {
            currentValue -= stepSize;
            setPremioValue(Math.round(currentValue));

            if (currentValue <= 0 || Math.abs(currentValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setPremioValue(0);
            }
        }, animationSpeed);
    };

    const animateBonusValue = (totalGameWinning) => {
        if (isAnimatingBonusValue) return;
        setIsAnimatingBonusValue(true);

        let currentValue = 0;
        const steps = 50;
        const stepSize = totalGameWinning / steps; // Increase step size
        const animationSpeed = 10;

        const intervalId = setInterval(() => {
            currentValue += stepSize;
            setBonusValue(Math.round(currentValue));

            if (currentValue >= totalGameWinning || Math.abs(totalGameWinning - currentValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setBonusValue(totalGameWinning);
                setIsAnimatingBonusValue(false);

                setTimeout(() => {
                    onBonusRoundCompleted(totalGameWinning);
                    interactionFlag = false;
                    setISAnimatingPremioValue(false);
                }, 6000);
            }
        }, animationSpeed);
    };
    const handleCauldronSound = () => {
        let wheelToggleClass = document.getElementById("cauldron04-bonusWin");
        let winningDiv = document.getElementById("cauldron04-premioWin");
        let startSound = document.getElementById("stakeNumStart");
        let endSound = document.getElementById("plopNumSound");

        setTimeout(() => {
            if (startSound) {
                let startSoundCount = 0;

                // setShowValue(true);
                const startSoundInterval = setInterval(() => {
                    if (startSoundCount < 2) {
                        wheelToggleClass.classList.add('d-none');
                        setTimeout(() => {
                            if (wheelToggleClass.classList.contains('d-none')) {
                                wheelToggleClass.classList.remove('d-none');
                            }
                        }, 200);
                        // setShowValue(prev => !prev);
                        if (startSound) {
                            startSound.play();
                        }
                        startSoundCount++;
                    } else {
                        clearInterval(startSoundInterval);
                        if (startSound) {
                            startSound.pause();
                        }
                        startSound.currentTime = 0;
                    }
                }, 900);
            }
        }, 2000);

        if (endSound) {
            setTimeout(() => {
                let endSoundCount = 0;

                const endSoundInterval = setInterval(() => {
                    if (endSoundCount < 3) {
                        winningDiv.classList.add('d-none');
                        setTimeout(() => {
                            if (winningDiv.classList.contains('d-none')) {
                                winningDiv.classList.remove('d-none');
                            }
                        }, 200);
                        if (endSound) {
                            endSound.play();
                        }
                        endSoundCount++;
                    } else {
                        clearInterval(endSoundInterval);
                        if (endSound) {
                            endSound.pause();
                        }
                        endSound.currentTime = 0;
                    }
                }, 900);
            }, 3700);
        }
    }

    const handleCauldronClick = (value, index) => {
        if (interactionFlag) return;
        if (value.disabled) return;

        interactionFlag = true;

        // Switch the clicked box to its "selected" view immediately so the
        // pumpkin-selected.gif shows right on click (no wait for the API response)
        setSelectedBoxIndex(index);

        // Update clicked box values
        const updatedBoxValues = [...boxValues];
        updatedBoxValues[index] = null;
        setBoxValues(updatedBoxValues);

        // Reveal the final value a FIXED time after the click (gif display time),
        // independent of how long the API takes. The reveal fires when BOTH the
        // gif timer has elapsed AND the API data is ready - whichever is later.
        let resolvedBoxValues = null;
        let revealTimerFired = false;
        let revealed = false;
        const revealSelectedValue = () => {
            if (revealed || !resolvedBoxValues || !revealTimerFired) return;
            revealed = true;
            setBoxValues(resolvedBoxValues);
            const gifEl = document.getElementById(`cauldron04-pumpkinGif-${index}`);
            const animEl = document.getElementById(`cauldron04-animImg-${index}`);
            if (gifEl) gifEl.classList.add("d-none");
            if (animEl) animEl.classList.remove("d-none");
        };
        setTimeout(() => {
            revealTimerFired = true;
            revealSelectedValue();
        }, 1500);

        // Add win animation class to clicked box
        const cauldronClickIndex = document.getElementById(`cauldronGame-04Click-${index}`);
        setTimeout(() => {
            if (cauldronClickIndex && !cauldronClickIndex.classList.contains("cauldron-select")) {
                cauldronClickIndex.classList.add("cauldron-select");
            }
        }, 2100)
        if (!selectedBoxArray.includes(value)) {
            setSelectedBoxArray((prev) => [...prev, value]);
        }

        let selectSoundplay = document.getElementById('jumpingPumpKin04_Select')

        stopBackgroundLoop();

        if (selectSoundplay) {
            selectSoundplay.currentTime = 0;
            selectSoundplay.play()
        }

        let payload = {
            bonusType: "Bonus03BPumpkin",
            recordId: gameSessionRecordId,
            tileNumber: index,
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            let res = response?.responsePacket;
            if (response?.errorCode === 0) {
                let bonusNumber = res?.bonusDetails?.bonus;
                let totalGameWinning = res?.totalWinnings
                let newOtherBoxWin = res?.otherPossibleWinningsNumber


                const updatedBoxValues = Array(boxesArr.length).fill(null);
                updatedBoxValues[index] = bonusNumber;

                // Assign unique random values to other boxes
                const otherIndexes = boxesArr.filter((_, i) => i !== index);
                const uniqueOtherValues = [...newOtherBoxWin];
                otherIndexes.forEach((_, i) => {
                    const randomIndex = Math.floor(Math.random() * uniqueOtherValues.length);
                    updatedBoxValues[otherIndexes[i]] = uniqueOtherValues.splice(randomIndex, 1)[0];
                });

                // Hand the resolved values to the click-relative reveal coordinator.
                // Reveal happens at click + 1200ms, or now if that already passed.
                resolvedBoxValues = updatedBoxValues;
                revealSelectedValue();

                setTimeout(() => {
                    if (selectSoundplay) {
                        selectSoundplay.pause();
                        selectSoundplay.currentTime = 0;
                    }
                }, 1800);

                if (bonusNumber > 0) {
                    setTimeout(() => {
                        handleCauldronSound();
                    }, 1500);
                    setTimeout(() => {
                        setPremioValue(() => {
                            let updatePremio = totalGameWinning;
                            animatePremioValue(updatePremio);
                            return updatePremio;
                        });
                        animateBonusValue(totalGameWinning);
                    }, 3000);
                }
                setTimeout(() => {
                    boxesArr.forEach((_, i) => {
                        const bonusElement = document.getElementById(
                            `bonus04-winning-${i}`
                        );
                        if (bonusElement) {
                            bonusElement.classList.remove("d-none");
                            bonusElement.classList.add("d-flex");
                        }
                    });
                    const premioBonusSound = document.getElementById("premioBonusValuesSound");
                    if (premioBonusSound) {
                        premioBonusSound.currentTime = 0;
                        premioBonusSound.play().catch((err) => {
                            console.error("premio_bonus audio play failed:", err);
                        });
                    }
                }, 2200);
            } else {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
        })
    };


    const loadStaticAudio = () => {
        return (
            <>
                <div style={{ display: "none" }}>
                    {/* Load Audio as Well */}
                    <audio controls=" " id="jumpingPumpKin04-Bg" className="audioFile">
                        <source src="assets/pumpkin-bg.ogg" type="audio/ogg" />
                    </audio>
                    <audio controls="" ref={jumpingPumpKin04_SelectRef} id="jumpingPumpKin04_Select" className="audioFile">
                        <source src="assets/bonus4_premioiwin.ogg" type="audio/ogg" />
                    </audio>
                    <audio controls="" id="plopNumSound" className="audioFile">
                        <source src="assets/plop.wav" type="audio/wav" />
                    </audio>
                    <audio controls="" id="stakeNumStart" className="audioFile">
                        <source src="assets/stake.mp3" type="audio/mpeg" />
                    </audio>
                    <audio controls="" id="premioBonusValuesSound" className="audioFile">
                        <source src="assets/premio_bonus.ogg" type="audio/ogg" />
                    </audio>
                </div>
            </>
        );
    };


    const drawBody = () => {
        return (
            <div className="cauldron-content bg-transparent">
                <div className="cauldron-inner-content">
                    <div className="text-center header-h" >
                        <img className="w-100 h-100" src="assets/img/cauldron/logo.png" alt="" />
                    </div>
                    <div className="cauldron-game-content border-0" style={{ height: "80%" }}>
                        <div className="d-flex h-100" style={{ gap: "5%", padding: "0 2% 0 4%", flex: "1", background: "#101010" }}>
                            {boxesArr.map((box, index) => (
                                <div
                                    id={`cauldronGame-04Click-${index}`}
                                    key={index}
                                    className="cauldron-game-content-col position-relative w-100 h-100"
                                    onClick={() => !interactionFlag && handleCauldronClick(index, box)}
                                >
                                    <div className="cauldron-img-2">
                                        {selectedBoxIndex === index ? (
                                            // Show animations and clicked box value
                                            <>
                                                <img
                                                    id={`cauldron04-pumpkinGif-${index}`}
                                                    className="cauldron-gif"
                                                    src={`assets/img/cauldron/pumpkin-selected.gif?v=${gameSessionRecordId + "-" + index}`}
                                                    alt=""
                                                />
                                                <img
                                                    id={`cauldron04-animImg-${index}`}
                                                    className="anim-selected d-none"
                                                    src={`assets/img/cauldron/pumpkin-selected-${boxValues[index]}.png`}
                                                    alt=""
                                                />

                                            </>
                                        ) : (
                                            // Show idle animation and random value for other boxes
                                            <>
                                                {selectedBoxIndex !== null && boxValues[index] > 0 && (
                                                    <img
                                                        id={`cauldron04-animImg-${index}`}
                                                        className="text-content-ani d-block"
                                                        src={`assets/img/cauldron/nu-pumpkin-selected-${boxValues[index]}.png`}
                                                        alt=""
                                                    />
                                                )}
                                                <img
                                                    src={`assets/img/cauldron/pumpkin-${index}.gif`}
                                                    className={selectedBoxIndex !== null && boxValues[index] > 0 ? "d-none" : "d-block"}
                                                    alt=""
                                                />

                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    const drawFooter = () => {
        return (
            <div className="cauldron-footer-content pt-2">
                <div className="cauldron-footer-top-content gap-5 ">
                    <div className="cauldron-footer-btn-box">
                        <div className=" d-flex w-100" style={{ height: "33.33%" }}>
                            <div className="col-5 text-center d-flex align-items-center justify-content-center">
                                <img className="w-75 h-75" src="assets/img/cauldron/text2.png" alt="" />
                            </div>
                            <div className="col-7 position-relative">
                                <span className="cauldron-btn position-absolute start-0 top-0 end-0 bottom-0 z-1" id="cauldron04-bonusWin">{isAnimatingPremioValue ? premioValue : gameResult.winnings}</span>
                                <img className="w-100 h-100" src="assets/img/cauldron/btn-bg.png" alt="" />
                            </div>
                        </div>
                        <div className=" d-flex w-100" style={{ height: "33.33%" }}>
                            <div className="col-5 text-center d-flex align-items-center justify-content-center">
                                <img className="w-75 h-75" src="assets/img/cauldron/text3.png" alt="" />
                            </div>
                            <div className="col-7 position-relative">
                                <span className="cauldron-btn position-absolute start-0 top-0 end-0 bottom-0 z-1">
                                    {getFormattedAmountWithDenomination(walletBalance, denomination)}
                                </span>
                                <img className="w-100 h-100" src="assets/img/cauldron/btn-bg.png" alt="" />
                            </div>
                        </div>
                        <div className=" d-flex w-100" style={{ height: "33.33%" }}>
                            <div className="col-5 text-center d-flex align-items-center justify-content-center">
                                <img className="w-75 h-75" src="assets/img/cauldron/text1.png" alt="" />
                            </div>
                            <div className="col-7 position-relative">
                                <span className="cauldron-btn position-absolute start-0 top-0 end-0 bottom-0 z-1" id="cauldron04-premioWin">{bonusValue}</span>
                                <img className="w-100 h-100" src="assets/img/cauldron/btn-bg.png" alt="" />
                            </div>
                        </div>
                    </div>

                    <div className="w-100">
                        <div className="text-center" style={{ height: "25%" }}>
                            <img className="img-fluid blink_me h-100 w-100" src="assets/img/cauldron/caldeirao-abobora-frase.png" alt="" />
                        </div>
                        <div className="text-center" style={{ height: "33.33%" }}>
                            <img className="img-fluid w-100 h-100" src="assets/img/cauldron/caldeirao-abobora-multiplique.png" alt="" />
                        </div>
                        <div className="cauldron-btn" style={{ height: "33.33%" }}>
                            <img className="img-fluid w-100 h-100" src="assets/img/cauldron/caldeirao-abobora-bonus.png" alt="" />
                        </div>
                    </div>
                </div>
                <div style={{ height: "15%" }}></div>
                <div className="cauldron-footer-bottom-content text-center ">
                    <img className=" img-fluid w-100 h-100 " src="assets/img/cauldron/footer-logo.png" alt="" />
                </div>
            </div>
        )
    }


    return (
        <>
            <div className="h-100 w-100 position-relative bomba-cauldron2">
                <img className="h-100 w-100" src="assets/img/cauldron/bg.jpg" alt="" />
                <div className="contentPosition p-0">
                    {drawBody()}
                    {drawFooter()}
                </div>
            </div>
            {loadStaticAudio()}
        </>
    );
}

export default BombaCauldronAboboraBonus;
